import Link from "next/link"
import type { ComponentPropsWithoutRef } from "react"

import type { NavigationItem } from "./type"

type NavigationLinkProps = Omit<ComponentPropsWithoutRef<"a">, "href" | "target" | "rel"> & {
  item: Pick<NavigationItem, "href" | "openInNewTab" | "reloadDocument">
}

/** 使用菜单数据中的导航策略，避免同源跨应用链接被 Next.js 路由接管。 */
export function NavigationLink({ item, ...props }: NavigationLinkProps) {
  const linkProps = {
    ...props,
    href: item.href || "#",
    ...(item.openInNewTab ? { target: "_blank", rel: "noopener noreferrer" } : {}),
  }

  return item.reloadDocument ? <a {...linkProps} /> : <Link {...linkProps} prefetch={false} />
}
